module.exports = {"pathContext":{"slug":"/en/corporate_program/","langKey":"en"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/en-corporate-program.json
// module id = 1139
// module chunks = 166349362330929